// extracted by mini-css-extract-plugin
export default {"row":"RatingStars_row__8aZCI","star":"RatingStars_star__dRXPR","big":"RatingStars_big__Nk7u7","label":"RatingStars_label__ZW6kF"};